import { SharedFollowingFanProjection } from '@api'
import type { ColumnDef } from '@tanstack/react-table'

import EyeIcon from '@/assets/icons/icon-eye.svg'
import { CreatorBrowserLink } from '@/components/ui/CreatorBrowserLink'
import { unescapeHtmlText } from '@/modules/chatting/ui/chat-window/fan-info/utils'

import { SharedFollowListCreatorsPopover } from './SharedFollowListCreatorsPopover'

export const SHARED_FOLLOWERS_COLUMNS: ColumnDef<SharedFollowingFanProjection>[] =
  [
    {
      accessorKey: 'fanName',
      header: 'Fan Name',
      size: 200,
      sortingFn: 'basic',
    },
    {
      accessorKey: 'commonCreatorsNames',
      header: 'Shared Following',
      size: 200,
      sortingFn: 'basic',
      cell: ({ row }) => {
        return (
          <div className="flex items-center gap-1">
            <span className="block max-w-[200px] truncate">
              {row.original.commonCreatorsNames
                ?.map(unescapeHtmlText)
                .join(', ')}
            </span>
            <SharedFollowListCreatorsPopover
              creators={row.original.commonCreatorsNames || []}
            />
          </div>
        )
      },
    },
    {
      accessorKey: '',
      header: 'Actions',
      cell: ({ row }) => {
        return (
          <div className="flex items-center justify-end gap-2">
            <CreatorBrowserLink
              tooltip="View Fan"
              href={`https://onlyfans.com/u${row.original.fanId}`}
            >
              <EyeIcon className="text-primary-500" />
            </CreatorBrowserLink>
          </div>
        )
      },
      meta: {
        isActionColumn: true,
      },
    },
  ]
